<template>

  <div class="container">

    <!--工具简介-->
    <div class="tools-intro" :style="{backgroundImage:'url('+require('../assets/banner-tools.png')+')'}" style=" background-size:100% 100%;">
      <div style="width: 1600px; align-items: center; margin: 0 auto; " >
        <el-image style="width: 100px; height: 100px; float: left" :src="require('@/assets/icon/xml.svg')"></el-image>
        <div style="position: relative;  left: 40px">
          <p style="font-size: 25px; font-weight: 600">XML代码格式化工具</p>
          <p>XML格式化采用xml-formatter插件实现</p>

        </div>

      </div>


    </div>

    <div style="width:1600px; margin:40px auto">
      <h3>操作区</h3>
      <el-button @click="Format" type="primary">格式化代码</el-button>
      <el-button   v-clipboard:copy="formatCode"
                   v-clipboard:success="onCopy"
                   v-clipboard:error="onError" type="success">粘贴至剪贴板</el-button>
    </div>

    <!--代码框-->
    <div style="width: 1600px;display: flex; justify-content: space-between;">

      <div style="width: 49%">
        <h3>待格式化XML</h3>
        <el-input class="inputCode" v-model="nativeCode"
                  type="textarea"
                  :rows="20"></el-input>
      </div>

      <div style="width: 49%">
        <h3>格式化XML</h3>
        <el-input class="inputCode" v-model="formatCode"
                  type="textarea"
                  :rows="20"></el-input>

      </div>
    </div>





  </div>
</template>

<script>

import xmlFormat from 'xml-formatter'
import {Message} from "element-ui";

export default {
  name: "XmlTools",
  data(){
    return{
      nativeCode: '',
      formatCode:'',

    }
  },
  methods:{


    Format(){


      // this.formatCode = JSON.stringify((this.nativeCode),null,2);



      this.formatCode = xmlFormat(this.nativeCode)
    },


    onCopy: function () {
      Message.success("已拷贝至剪贴板！")
      // alert('You just copied: ' + e.text)
    },
    onError: function () {
      Message.warning("拷贝失败，请确认格式化区域是否有内容")

    },


  }
}
</script>

<style scoped>
.container{
  text-align: left;
  display: flex;
  flex-direction: column;
  /*justify-content: center;    !* 垂直居中 *!*/
  align-items: center;        /* 水平居中 */
  background: #FAFCFF;
  height: 100%;
}


.tools-intro{

  width: 100%;
  height: 200px;
  box-shadow: 0px 0px 40px 0px rgb(217, 224, 234);


}



/deep/ .el-textarea__inner {
  font-family: sans-serif !important;

}

/deep/.el-button.el-button--primary{
  background:#4154F1
}

/deep/.el-button.el-button--success{
  background:#28bd6c
}



</style>
